import { TemplateWithAccess } from "features/allTemplates";

// Unicode lock character used to indicate read-only templates in the sidebar
const LOCK = "\u{1F512}";

/**
 * Builds a single flat nav item list from TemplateWithAccess[].
 * Accessible templates appear first (sorted alphabetically),
 * then inaccessible ones with a lock indicator (also sorted).
 */
export const getTemplateNavItems = (templates: TemplateWithAccess[]) => {
  const accessible = templates
    .filter((t) => t.hasAccess)
    .sort((a, b) => a.id.localeCompare(b.id))
    .map((t) => ({
      type: "link" as const,
      text: t.id,
      href: `/template/${t.id}`,
    }));

  const inaccessible = templates
    .filter((t) => !t.hasAccess)
    .sort((a, b) => a.id.localeCompare(b.id))
    .map((t) => ({
      type: "link" as const,
      text: `${LOCK} ${t.id}`,
      href: `/template/${t.id}`,
    }));

  return [...accessible, ...inaccessible];
};
